import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { CheckCircle2, Circle, Rocket, X } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const WelcomeTourCard = ({ token }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    axios.get(`${API}/onboarding/tour`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setStatus(r.data))
      .catch(() => setStatus(null));
  }, [token]);

  if (!status || status.dismissed || status.complete) return null;
  const done = status.steps.filter((s) => s.done).length;

  const dismiss = async () => {
    setStatus({ ...status, dismissed: true });
    try {
      await axios.post(`${API}/onboarding/tour/dismiss`, {}, { headers: { Authorization: `Bearer ${token}` } });
    } catch { /* best effort */ }
  };

  return (
    <Card className="shadow-xl mb-6 border-2 border-blue-700/50" data-testid="welcome-tour-card">
      <CardContent className="p-5">
        <div className="flex items-center gap-2 mb-1">
          <Rocket className="w-5 h-5 text-blue-300" />
          <h2 className="text-base font-bold text-white">Welcome to HinesTime — let&apos;s get you to your first punch</h2>
          <button onClick={dismiss} className="ml-auto p-1 rounded hover:bg-slate-700/50" title="Dismiss setup guide" data-testid="welcome-tour-dismiss">
            <X className="w-4 h-4 text-slate-400" />
          </button>
        </div>
        <p className="text-xs mb-3" style={{ color: '#94A3B8' }}>
          {done} of {status.steps.length} steps done — tap a step to jump there.
        </p>
        <div className="space-y-1.5">
          {status.steps.map((s) => (
            <button
              key={s.key}
              onClick={() => navigate(s.link)}
              className="w-full flex items-center gap-2 text-left text-sm rounded-md px-2 py-1.5 hover:bg-slate-700/40"
              data-testid={`welcome-step-${s.key}`}
            >
              {s.done
                ? <CheckCircle2 className="w-4 h-4 text-emerald-400 shrink-0" />
                : <Circle className="w-4 h-4 text-slate-500 shrink-0" />}
              <span className={s.done ? 'text-slate-500 line-through' : 'text-white'}>
                {s.label}{s.optional ? ' (optional)' : ''}
              </span>
            </button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default WelcomeTourCard;
